import { createSlice } from "@reduxjs/toolkit";

// Local UI state shared between the geofence panel and the map components.
// Used to trigger an on-map geometry redraw for an existing fence from the
// panel's "resize" button.
const geofenceUiSlice = createSlice({
  name: "geofenceUi",
  initialState: {
    // { id, name, color } of the fence whose shape is being redrawn, or null
    redrawGeofence: null,
  },
  reducers: {
    startGeofenceRedraw: (state, action) => {
      state.redrawGeofence = action.payload;
    },
    clearGeofenceRedraw: (state) => {
      state.redrawGeofence = null;
    },
  },
});

export const { startGeofenceRedraw, clearGeofenceRedraw } = geofenceUiSlice.actions;
export default geofenceUiSlice.reducer;
